import { createAction, props } from '@ngrx/store';
import { InsightsApiError } from './insights.errors';
import { Insights, InsightsFilter } from './insights.model';

export const LoadInsights = createAction(
  '[Insights] Load Insights',
  props<{ projectId: number; filters?: InsightsFilter }>(),
);

export const LoadInsightsCsv = createAction(
  '[Insights] Load Insights Csv',
  props<{ projectId: number; filters?: InsightsFilter }>(),
);

export const SetInsights = createAction('[Insights] Set Insights', props<{ insights: Insights }>());

export const InsightsCsvLoaded = createAction('[Insights] Insights Csv Loaded');

export const SetInsightsApiError = createAction(
  '[Insights] Set Insights ApiError',
  props<{ error: InsightsApiError }>(),
);

export const RemoveInsightsApiError = createAction('[Insights] Remove Insights ApiError');
